import 'css-chunksrc/client/scenes/listRemoval/listsList/list/task/styles.scss';export default {
  "task": "_task_1heu1_1",
  "contextualMenu": "_contextualMenu_1heu1_8",
  "taskDetails": "_taskDetails_1heu1_12",
  "name": "_name_1heu1_22",
  "icon": "_icon_1heu1_39",
  "taskAdvancement": "_taskAdvancement_1heu1_43",
  "allocations": "_allocations_1heu1_49",
  "text": "_text_1heu1_56",
  "completionDate": "_completionDate_1heu1_62",
  "tick": "_tick_1heu1_68",
  "late": "_late_1heu1_75",
  "displayedContextualMenu": "_displayedContextualMenu_1heu1_86",
  "taskStatus": "_taskStatus_1heu1_90",
  "placeholder": "_placeholder_1heu1_96",
  "row": "_row_1heu1_101",
  "comments": "_comments_1heu1_106"
};